import { SVGProps } from 'react';

const UploadSingle = ({
  width = 23,
  height = 23,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 23"
    {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8999 14.7206C12.8999 15.2727 12.4524 15.7203 11.9003 15.7204C11.348 15.7205 10.9003 15.2728 10.9003 14.7206V3.40044L7.70024 6.60053C7.34002 7.00065 6.7002 7.00065 6.30009 6.60053C5.89997 6.24032 5.89997 5.6005 6.30009 5.20038L11.1801 0.280138C11.3799 0.0800792 11.6198 0 11.9 0C12.1798 0 12.4198 0.0800792 12.6198 0.280138L17.5002 5.20009C17.9003 5.56031 17.9003 6.20013 17.5002 6.60025C17.1399 7.00036 16.5001 7.00036 16.1 6.60025L12.8999 3.40016V14.7206ZM0 13H2V18C2 19.6569 3.34315 21 5 21H18C19.6569 21 21 19.6569 21 18V13H23V18C23 20.7614 20.7614 23 18 23H5C2.23858 23 0 20.7614 0 18V13Z"
      fill={fill}
    />
  </svg>
);

export default UploadSingle;
